(() => {
  function initialise(root = document) {
    root.querySelectorAll('[data-sg-make-menu]').forEach(menu => {
      if (menu.dataset.makeReady) return;
      menu.dataset.makeReady = 'true';
      const ranges = [...menu.querySelectorAll('.sg-range')];
      const desktop = menu.dataset.mode === 'desktop';
      function choose(range) {
        ranges.forEach(other => { if (other !== range) other.open = false; });
        range.open = true;
      }
      ranges.forEach(range => {
        const trigger = range.querySelector('.sg-range-trigger');
        trigger.addEventListener('pointerenter', event => {
          if (desktop && event.pointerType === 'mouse') choose(range);
        });
        trigger.addEventListener('click', event => {
          if (desktop) { event.preventDefault(); choose(range); }
        });
        range.addEventListener('toggle', () => {
          if (range.open) ranges.forEach(other => { if (other !== range) other.open = false; });
        });
        trigger.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') {
            event.preventDefault(); choose(range);
            range.querySelector('.sg-make-view-all')?.focus();
          }
        });
        range.querySelector('.sg-make-panel').addEventListener('keydown', event => {
          if (event.key === 'Escape' || event.key === 'ArrowLeft') {
            event.preventDefault(); event.stopPropagation();
            if (!desktop) range.open = false;
            trigger.focus();
          }
        });
      });
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  const header = document.getElementById('header-group');
  if (header) new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) initialise(header);
  }).observe(header, { childList: true, subtree: true });
})();
